"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var commentsCtrl = function($scope, $uibModalInstance, $q, $http, $timeout, commentsParams) {
  var ctrl = this;
  var init = function() {
    $scope.comments = commentsParams.comments;
    $scope.ctrl = ctrl;
    $timeout(function() {
      angular.element('.modal.in textarea').focus();
    });
  };
  ctrl.addComment = function() {
    $scope.comments.push({text: $scope.newComment});
    $scope.newComment = null;
  };
  ctrl.deleteComment = function(index) {
    $scope.comments.splice(index, 1);
  };
  init();
};
commentsCtrl.$inject = ['$scope', '$uibModalInstance', '$q', '$http', '$timeout', 'commentsParams'];
module.exports = commentsCtrl;
